import * as types from '../actions/actionTypes';

const initialState = {
  qtCategoriesLoaded: [], // includes visualizers
  qtCategoriesRequested: [], // includes visualizers
  qtActiveCategory: "", //string!! look for all the category here: layout.qtCategories.find(qtCategory => qtCategory.name === this.props.qtActiveCategory);
};

export default function (state = initialState, action) {

  switch (action.type) {

    case types.SET_QT_CATEGORIES_LOADED:
      return Object.assign({}, state, {
        qtCategoriesLoaded: [...state.qtCategoriesLoaded, action.payload.qtCategoriesLoaded]
      });
    case types.SET_QT_CATEGORIES_REQUESTED:
      return Object.assign({}, state, {
        qtCategoriesRequested: [...state.qtCategoriesRequested, action.payload.qtCategoriesRequested]
      });
    case types.SET_QT_ACTIVE_CATEGORY:
      return Object.assign({}, state, {
        ...action.payload
      });
  }

  return state;

}
